import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Button from 'src/components//button/Button'
import Header from 'src/components//header/Header'
import styles from './addresses.module.scss'
import { usePagination, useSortBy, useTable } from 'react-table'
import { baseApiURL } from 'src/utils/utils'
import axios from 'axios'
import { StateContext, DispatchContext } from '../../AppContext'
import { IAddress, IState, ParamTypes } from 'src/Interface'
import Footer from 'src/components/footer/Footer'
import Table from 'src/components/table/Table'
import { toast } from 'react-toastify'
import SubHeader from 'src/components/subHeader/SubHeader'
import useCancellablePromise from 'src/utils/useCancellablePromise'

const Addresses: React.FunctionComponent = () => {
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const state: IState = useContext(StateContext)
  const [loading, setLoading] = useState(true)
  const location: any = useLocation()
  const { cancellablePromise } = useCancellablePromise()
  const { branchId, companyId } = useParams<ParamTypes>()
  const [data, setData] = useState([])
  const [changedData, setChangedData] = useState([])
  useEffect(() => {
    if (state.user.accessToken) {
      cancellablePromise(axios(`${baseApiURL()}/branches/${branchId}/predefined_addresses`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result: any) => {
        setLoading(false)
        dispatch({ type: 'SET_ADDRESSES', addresses: result.data })
      }).catch((err) => {
        toast(err.response.message)
        setLoading(false)
      }))
    }
  }, [branchId, state.user.accessToken, dispatch, cancellablePromise])

  useEffect(() => {
    setData(state.addresses)
    setChangedData(state.addresses)
  }, [state.addresses])

  const  changeRowPosition=(e:any,selectedRow:IAddress,state:string)=>{
    e.stopPropagation(); 
    const index= changedData.findIndex((item:any)=>item.id===selectedRow.id)
     
    const swapIndex = state==="Increase"? index + 1:index - 1
    
    if(swapIndex===-1 || swapIndex===data.length)
    return

    const sortedData=changedData
    const sortOrder=sortedData[index].sortOrder
    sortedData[index].sortOrder=sortedData[swapIndex].sortOrder
    sortedData[swapIndex].sortOrder=sortOrder
    setData(sortedData.sort((a:IAddress,b:IAddress)=>a.sortOrder-b.sortOrder))
  }
  function saveSortOrder(e:any){
    e.stopPropagation(); 
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/branches/${branchId}/predefined_addresses`,
        changedData, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then(() => {
          return null
        }).then(() => {
          return axios(`${baseApiURL()}/branches/${branchId}/predefined_addresses`, {
            headers: {
              Authorization:
                `Bearer ${state.user.accessToken}`
            }
          })
        }).then((result: any) => {
          dispatch({ type: 'SET_ADDRESSES', addresses: result.data })
          close()
        }).catch((err: any) => {
          toast(err.response.data.message)
        })
    }
    
  }

  const columns = useMemo(() => [
    {
      Header: 'Vejnavn',
      accessor: 'streetName',
      Cell: ({ cell }: any) => {
        return <span className='tw-flex tw-items-center'> {cell.value}</span> 
      },
    },
    {
      Header: 'Husnummer',
      accessor: 'houseLetter',
      Cell: ({ cell }: any) => {
        return <span>{cell.row.original.houseNo}{cell.row.original.houseLetter}</span>
      }
    },
    {
      Header: 'By',
      accessor: 'city'
    },
    {
      Header: 'Postnummer',
      accessor: 'zipCode'
    },
    {
      Header: 'POI',
      accessor: 'poi'
    },
    {
      Header:JSON.stringify(state.addresses)===JSON.stringify(changedData)? 'Sort' : <Button type='primary' label='Gem Sortering' handleClick={saveSortOrder} />,
      accessor: 'sortOrder',
      disableSortBy:true,
      type:'button',
      Cell: ({row}: any) => {
        return <span className='tw-flex'>
          <svg onClick={(e)=>{changeRowPosition(e,row.original,"Decrease")}} className='tw-w-4 tw-h-4' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>   
          <svg onClick={(e)=>{changeRowPosition(e,row.original,"Increase")}} className='tw-w-4 tw-h-4 tw-ml-2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg> 
        </span >
      }
    }
  ], [changedData])
  
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    nextPage,
    gotoPage,
    canNextPage,
    canPreviousPage,
    state: pageState,
    previousPage,
    prepareRow,
    sortedRows
  } = useTable({
    columns,
    data,
    autoResetPage: false
  }, useSortBy, usePagination)
  useEffect(()=>{
    const rows=sortedRows.map((item:any)=>item.original)
    setChangedData(rows.map((item:IAddress,index:number)=>{item.sortOrder=index; return item}))
  },[pageState.sortBy])

  return (
    <>
      <Header />
      <SubHeader loading={loading} backPath={location.state.backPath ? location.state.backPath : '/companies'} title={
        <>
          <svg className='arrow-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span className='color-gray tw-font-normal'>{location.state.from}</span> <span className='tw-mx-3 color-gray tw-font-normal'>/</span> <span className='text-black text-bold'>Favoritadresser</span>
        </>
      }>
        <Button disabled={JSON.stringify(state.addresses)!==JSON.stringify(changedData)} modifiers='tw-ml-auto' type='primary' label='Opret favoritadresse' handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addAddress', branchId })} />
      </SubHeader>
      <main className={styles.container}>
        <Table
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          prepareRow={prepareRow}
          loading={loading}
          page={page}
          handleClick={(addressId) => dispatch({ type: 'SHOW_ASIDE', show: true, asideType: 'AddressDetails', addressId, branchId, size: 'small' })}
          headerGroups={headerGroups}
          type='addresses'
          companyId={companyId}
          branchId={branchId}
          state={{ background: location }}
        />
      </main>
      <Footer
        pageState={pageState}
        canNextPage={canNextPage}
        nextPage={nextPage}
        loading={loading}
        paginationLabel=''
        canPreviousPage={canPreviousPage}
        page={page}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageOptions={pageOptions}
        itemsLength={state.addresses.length}
      />
    </>
  )
}

export default Addresses
